(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["moruga-catalog-video"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mc-video]').forEach((root)=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const video=root.querySelector('video'),play=root.querySelector('.mc-video-play'),pause=root.querySelector('.mc-video-pause');
  const sync=()=>{play.hidden=!video.paused;pause.hidden=video.paused;};
  play.addEventListener('click',()=>{video.play().catch(sync);});
  pause.addEventListener('click',()=>video.pause());
  video.addEventListener('click',(event)=>{if(event.offsetY<video.clientHeight-56){event.preventDefault();if(video.paused)video.play().catch(sync);else video.pause();}});
  ['play','pause','ended'].forEach(name=>video.addEventListener(name,sync));
  sync();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moruga-lab-heavy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.labHeavyReady === 'true') return;
      root.dataset.labHeavyReady = 'true';
      const buttons = [...root.querySelectorAll('[data-heavy-button]')];
      const panels = [...root.querySelectorAll('[data-heavy-panel]')];
      const select = (id) => {
        buttons.forEach((button) => {
          const active = button.dataset.heavyButton === id;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          const active = panel.dataset.heavyPanel === id;
          panel.hidden = !active;
          if (!active) return;
          const rows = [...panel.querySelectorAll('.mrg-lab-heavy__row')];
          if (panel.classList.contains('is-status')) return;
          const values = rows.map((row) => (row.dataset.value || '').trim()).filter(Boolean).map(Number).filter(Number.isFinite);
          const max = Math.max(...values, 1);
          rows.forEach((row) => {
            const raw = (row.dataset.value || '').trim();
            const value = raw === '' ? null : Number(raw);
            row.style.setProperty('--lab-heavy-bar', Number.isFinite(value) ? Math.max(.035, value / max) : 0);
          });
        });
      };
      buttons.forEach((button) => button.addEventListener('click', () => select(button.dataset.heavyButton)));
      buttons.forEach((button, index) => button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let target = index;
        if (event.key === 'ArrowLeft') target = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'ArrowRight') target = (index + 1) % buttons.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = buttons.length - 1;
        select(buttons[target].dataset.heavyButton);
        buttons[target].focus();
      }));
      if (buttons[0]) select(buttons[0].dataset.heavyButton);
      document.addEventListener('shopify:block:select', (event) => {
        const panel = root.querySelector(`[data-block-id="${event.detail.blockId}"]`);
        if (panel) select(panel.dataset.heavyPanel);
      });
    };
    document.querySelectorAll('[data-lab-heavy]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moruga-lab-metric-explorer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.labExplorerReady === 'true') return;
      root.dataset.labExplorerReady = 'true';
      const groups = [...root.querySelectorAll('[data-lab-group]')];
      const buttons = [...root.querySelectorAll('[data-lab-metric-button]')];
      const panels = [...root.querySelectorAll('[data-lab-metric-panel]')];
      const selectedByGroup = {};

      const sizeBars = (panel) => {
        const rows = [...panel.querySelectorAll('.mrg-lab-metric__row')];
        const values = rows.map((row) => (row.dataset.value || '').trim()).filter(Boolean).map(Number).filter(Number.isFinite);
        const max = Math.max(...values, 1);
        rows.forEach((row) => {
          const raw = (row.dataset.value || '').trim();
          const value = raw === '' ? null : Number(raw);
          const ratio = Number.isFinite(value) ? Math.max(value === 0 ? .02 : .04, value / max) : 0;
          row.style.setProperty('--lab-bar', ratio);
        });
      };

      const selectMetric = (id) => {
        const button = buttons.find((item) => item.dataset.labMetricButton === id);
        if (!button) return;
        selectedByGroup[button.dataset.group] = id;
        buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        panels.forEach((panel) => {
          const active = panel.dataset.labMetricPanel === id;
          panel.hidden = !active;
          if (active) sizeBars(panel);
        });
      };

      const selectGroup = (group) => {
        groups.forEach((button) => button.setAttribute('aria-selected', String(button.dataset.labGroup === group)));
        const available = buttons.filter((button) => button.dataset.group === group);
        buttons.forEach((button) => { button.hidden = button.dataset.group !== group; });
        const id = selectedByGroup[group] || available[0]?.dataset.labMetricButton;
        if (id) selectMetric(id);
      };

      groups.forEach((button) => button.addEventListener('click', () => selectGroup(button.dataset.labGroup)));
      buttons.forEach((button) => button.addEventListener('click', () => selectMetric(button.dataset.labMetricButton)));
      const firstGroup = buttons[0]?.dataset.group || 'antioxidants';
      selectGroup(firstGroup);

      document.addEventListener('shopify:block:select', (event) => {
        const panel = root.querySelector(`[data-block-id="${event.detail.blockId}"]`);
        if (!panel) return;
        selectGroup(panel.dataset.group);
        selectMetric(panel.dataset.labMetricPanel);
      });
    };
    document.querySelectorAll('[data-lab-explorer]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();
})();
